/* gd-predictive-search
   ヘッダー検索欄の予測検索。Section Rendering API で HTML を取得して差し込む。
   価格整形は Liquid 側（gd-money）で行うため JS 側では通貨を扱わない。 */
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE = 220;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function init() {
    var input = document.getElementById('gd-search-input');
    var panel = document.getElementById('gd-predictive-results');
    if (!input || !panel || input.dataset.gdBound) return;
    input.dataset.gdBound = '1';

    var wrap = input.closest('.gd-nav-search');
    var timer, controller, activeIndex = -1;

    function options() {
      return panel.querySelectorAll('[role="option"] a');
    }

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
      if (wrap) wrap.classList.remove('is-suggesting');
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      if (wrap) wrap.classList.add('is-suggesting');
    }

    function highlight(index) {
      var items = options();
      if (!items.length) return;
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;
      activeIndex = index;
      items.forEach(function (a, i) {
        a.classList.toggle('is-active', i === index);
        a.parentElement.setAttribute('aria-selected', String(i === index));
      });
      items[index].scrollIntoView({ block: 'nearest' });
    }

    function search(term) {
      if (controller) controller.abort();
      controller = new AbortController();

      var url = rootUrl() + 'search/suggest'
        + '?q=' + encodeURIComponent(term)
        + '&section_id=gd-predictive-search'
        + '&resources[type]=product,collection,article'
        + '&resources[limit]=5'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      fetch(url, { signal: controller.signal, headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.gd-ps-list, .gd-ps-empty');
          panel.innerHTML = inner ? inner.outerHTML : '';
          if (panel.innerHTML.trim()) { open(); } else { close(); }
          activeIndex = -1;
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') close();
        });
    }

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'gd-predictive-results');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < MIN_CHARS) { close(); return; }
      timer = setTimeout(function () { search(term); }, DEBOUNCE);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && panel.innerHTML.trim()) open();
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(activeIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(activeIndex - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        options()[activeIndex].click();
      }
    });

    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && e.target !== input) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
